"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var UnmanagedTooltipIcon_1 = require("../UnmanagedTooltipIcon");
var ColorStripe_1 = require("../ColorStripe");
var dom_1 = require("../../utils/dom");
var propTypes = {
    steps: PropTypes.arrayOf(PropTypes.node).isRequired,
    activeStepIndex: PropTypes.number.isRequired,
    goToStepByIndex: PropTypes.func,
    variant: PropTypes.string,
    dockOnId: PropTypes.string
};
var defaultProps = {
    steps: [],
    activeStepIndex: 0,
    goToStepByIndex: undefined,
    variant: 'default',
    dockOnId: undefined
};
/**
 * The `StepNavigation` component indicates the user's progress within a
 * certain workflow.
 * Usually the component is used within a tariff calculation wizard. In the
 * first step the user might provide his personal information, in the second
 * step his address information, in the third step the bank account data and in
 * the last step the user can sign an insurance policy with the help of a
 * [SalesmanButton](#!/SalesmanButton).
 *
 * The user can navigate back to already completed steps.
 * The callback funtion `goToStepByIndex` should be passed as a prop and listen
 * for step changes.
 */
exports.StepNavigation = function (props) {
    var _a = react_1.useState(false), toggleTooltip = _a[0], setToggleTooltip = _a[1];
    var colorStripeRef = react_1.createRef();
    var _b = react_1.useState(undefined), calculatedMarginTop = _b[0], setCalculatedMarginTop = _b[1];
    var goToStepByIndex = props.goToStepByIndex, variant = props.variant, steps = props.steps, className = props.className;
    var activeStepIndex = Math.max(0, props.activeStepIndex);
    var isVariantLight = variant === 'light';
    if (props.dockOnId) {
        react_1.useEffect(function () {
            if (isVariantLight && calculatedMarginTop === undefined) {
                var dockOnElement = document.getElementById(props.dockOnId);
                if (dockOnElement && colorStripeRef && colorStripeRef.current) {
                    var distance = dom_1.getDistanceOfElements(dockOnElement, colorStripeRef.current);
                    setCalculatedMarginTop(distance * -1);
                }
            }
        }, [colorStripeRef]);
    }
    var goToStep = function (event) {
        setToggleTooltip(false);
        if (typeof goToStepByIndex !== 'function') {
            return;
        }
        var index = Number(event.currentTarget.getAttribute('data-index'));
        goToStepByIndex(index);
    };
    var renderStep = function (step, index, isTooltip) {
        var hasGoToStepByIndexHandler = typeof goToStepByIndex === 'function';
        var done = activeStepIndex > index;
        var active = activeStepIndex === index;
        var stepClassName = classNames('ee_step-navigation__step', {
            'ee_step-navigation__step--active': active,
            'ee_step-navigation__tooltip-step': isTooltip
        });
        var buttonClassName = classNames('ee_step-navigation__button', {
            'ee_step-navigation__button--has-handler': hasGoToStepByIndexHandler
        });
        return (React.createElement("li", { key: "step-" + index, className: stepClassName },
            React.createElement("button", { type: "button", className: buttonClassName, disabled: !done || !hasGoToStepByIndexHandler, onClick: goToStep, "data-index": index },
                !isTooltip && isVariantLight && (React.createElement("span", { className: 'ee_step-navigation__decoration' }, "Schritt " + (index + 1) + " von " + steps.length)),
                React.createElement("span", { className: 'ee_step-navigation__label' }, step))));
    };
    var tooltipClickHandler = function () {
        setToggleTooltip(!toggleTooltip);
    };
    var renderSteps = function (isTooltip) {
        return steps.map(function (step, index) { return renderStep(step, index, isTooltip); });
    };
    var isCompletelyChecked = function () {
        var stepsLength = steps.length;
        return activeStepIndex >= stepsLength;
    };
    var renderOrderedList = function (isTooltip) {
        if (isTooltip === void 0) { isTooltip = false; }
        var componentClassName = classNames(className, 'ee_step-navigation', {
            'ee_step-navigation--all-checked': isCompletelyChecked(),
            'ee_step-navigation--light': isVariantLight,
            'ee_step-navigation__tooltip': isTooltip
        });
        return React.createElement("ol", { className: componentClassName }, renderSteps(isTooltip));
    };
    var renderVariantLight = function () {
        return (React.createElement(ColorStripe_1.ColorStripe, { ref: colorStripeRef, style: { marginTop: calculatedMarginTop } },
            React.createElement("div", { className: "ee_step-navigation__wrapper--light" },
                renderOrderedList(),
                React.createElement(UnmanagedTooltipIcon_1.UnmanagedTooltipIcon, { className: "ee_step-navigation__tooltip-button", isOpen: toggleTooltip, onToggleOpen: tooltipClickHandler }, renderOrderedList(true)))));
    };
    return React.createElement(React.Fragment, null, isVariantLight ? renderVariantLight() : renderOrderedList());
};
exports.StepNavigation.propTypes = propTypes;
exports.StepNavigation.defaultProps = defaultProps;
exports.default = exports.StepNavigation;
//# sourceMappingURL=StepNavigation.js.map